export default "__VITE_ASSET__BLHR8jJb__"